import React from "react"
import styled from "styled-components"

import { PlanSummaryСardHeader, PlanSummaryСardHeaderProps } from "./header"
import { PlanSummaryСardBody } from "./body"
import { PlanSummaryСardFooter, PlanSummaryСardFooterProps } from "./footer"

import { Flex } from "components/box"

export type PlanSummaryСardProps = {
  productDescription?: string
  cadenceDescription?: string
  price?: string
  discountPrice?: string
} & PlanSummaryСardHeaderProps &
  PlanSummaryСardFooterProps

const Container = styled(Flex).attrs({
  flexDirection: "column",
  pb: 6,
  pt: [5, null, "1.375rem"]
})`
  border-top: 2px solid ${props => props.theme.colors.iceBlue};

  &:first-of-type {
    border-top: none;
  }

  &:last-of-type {
    padding-bottom: ${props => props.theme.space[7]};
    margin-bottom: ${props => props.theme.space[9]};
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}px) {
    border-top: 1px solid ${props => props.theme.colors.peach};

    &:last-of-type {
      padding-bottom: ${props => props.theme.space[8]};
      margin-bottom: 0;
    }
  }

  background-color: transparent;
`

const PlanSummaryСard: React.FC<PlanSummaryСardProps> = ({
  name,
  productDescription,
  cadenceDescription,
  price,
  discountPrice,
  onEdit,
  onRemove
}) => (
  <Container>
    <PlanSummaryСardHeader name={name} price={price} discountPrice={discountPrice} />
    {(productDescription || cadenceDescription) && (
      <PlanSummaryСardBody cadenceDescription={cadenceDescription} productDescription={productDescription || ""} />
    )}
    <PlanSummaryСardFooter onEdit={onEdit} onRemove={onRemove} />
  </Container>
)

export default PlanSummaryСard
